import React, {ReactElement} from 'react';
import Props from './typings';
import StyledRibbonLabel from './styles';

const RibbonLabel = ({children, color = 'green'}: Props): ReactElement => {
  return <StyledRibbonLabel $color={color}>{children}</StyledRibbonLabel>;
};

export default RibbonLabel;
